module.exports = __webpack_public_path__ + "static/img/2areaA_57.386c0c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/2areaA_57.png
// module id = 812
// module chunks = 1